import { render, staticRenderFns } from "./NewsRecommend.vue?vue&type=template&id=5d89c073&scoped=true&"
import script from "./NewsRecommend.vue?vue&type=script&lang=js&"
export * from "./NewsRecommend.vue?vue&type=script&lang=js&"
import style0 from "./NewsRecommend.vue?vue&type=style&index=0&id=5d89c073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89c073",
  null
  
)

export default component.exports